import { useCallback } from "react";
const useStorage = (storage) => {
    const getStorage = useCallback((key, defaultValue) => {
        if (!storage) {
            return defaultValue;
        }
        const storedValue = storage.getItem(key);
        if (!storedValue) {
            return defaultValue;
        }
        try {
            return JSON.parse(storedValue);
        }
        catch (error) {
            console.error(`Error parsing storage key "${key}":`, error);
            return defaultValue;
        }
    }, [storage]);
    const setStorage = useCallback((key, value) => {
        if (!storage)
            return;
        try {
            storage.setItem(key, JSON.stringify(value));
        }
        catch (error) {
            console.error(`Error setting storage key "${key}":`, error);
        }
    }, [storage]);
    const removeStorage = useCallback((key) => {
        if (!storage)
            return;
        storage.removeItem(key);
    }, [storage]);
    return { getStorage, setStorage, removeStorage };
};
export function useLocalStorage() {
    const storage = typeof window !== "undefined" ? window.localStorage : undefined;
    return useStorage(storage);
}
export function useSessionStorage() {
    const storage = typeof window !== "undefined" ? window.sessionStorage : undefined;
    return useStorage(storage);
}
//# sourceMappingURL=useStorage.js.map